module.exports = __webpack_public_path__ + "static/2-35cb72c25850d5e3320e2742a89f2106.jpg";